export default __webpack_public_path__ + "static/media/y-saatio-omam2-logo.3c57cfc3.png";